import { Guid } from "@/Common/Models/Guid";

class EncounterNote {
    public Id: string;
    public EncounterId: Guid;
    public EmployeeId: Guid;
    public DateAdded: Date;
    public Note: string;
    public Context: string;
}

export { EncounterNote };
